<template>
  <div class="author">
    <a-visibility hide :on="[$breakpoint.mobile]">
      <a-lazy-hydrate
        when-visible
        :key="
          $_lazyHydratedComponentState_getHydratedComponentRefreshKey(
            $options.consts.HYDRATED_SECTION_NAME.AUTHOR_CONTENT_DESKTOP
          )
        "
      >
        <author-details-desktop
          v-bind="author"
          @mounted="
            $_lazyHydratedComponentState_onHydratedComponentMounted(
              $options.consts.HYDRATED_SECTION_NAME.AUTHOR_CONTENT_DESKTOP
            )
          "
        />
      </a-lazy-hydrate>
    </a-visibility>

    <a-visibility show :on="[$breakpoint.mobile]">
      <a-lazy-hydrate
        when-visible
        :key="
          $_lazyHydratedComponentState_getHydratedComponentRefreshKey(
            $options.consts.HYDRATED_SECTION_NAME.AUTHOR_CONTENT_MOBILE
          )
        "
      >
        <author-details-mobile
          v-bind="author"
          @mounted="
            $_lazyHydratedComponentState_onHydratedComponentMounted(
              $options.consts.HYDRATED_SECTION_NAME.AUTHOR_CONTENT_MOBILE
            )
          "
        />
      </a-lazy-hydrate>
    </a-visibility>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import mixins from '@/utils/mixins'
import AuthorDetailsDesktop from '@/components/_sections/author/AuthorDetails/AuthorDetailsDesktop/index.vue'
import AuthorDetailsMobile from '@/components/_sections/author/AuthorDetails/AuthorDetailsMobile/index.vue'

const HYDRATED_SECTION_NAME = {
  AUTHOR_CONTENT_DESKTOP: 'AUTHOR_CONTENT_DESKTOP',
  AUTHOR_CONTENT_MOBILE: 'AUTHOR_CONTENT_MOBILE'
}

export default {
  name: 'AuthorDetails',
  mixins: [mixins.lazyHydratedComponentState],
  components: {
    AuthorDetailsMobile,
    AuthorDetailsDesktop
  },
  props: {
    author: propValidator([PROP_TYPES.OBJECT])
  },
  consts: {
    HYDRATED_SECTION_NAME
  },
  methods: {
    rerenderNonHydratedComponents() {
      this.$_lazyHydratedComponentState_rerenderNonHydratedComponents(
        Object.values(HYDRATED_SECTION_NAME)
      )
    }
  }
}
</script>

<style lang="scss">
.author {
  margin-bottom: 60px;

  @include mobile {
    margin-top: 0;
    margin-bottom: 20px;
  }

  .author__logo-and-statistic {
    margin-right: 60px;

    @include desktop-lg {
      margin-right: 40px;
    }

    @include desktop-sm {
      margin-right: 20px;
    }
  }

  .author__content-desktop {
    display: flex;
  }

  .author__content-top-section {
    display: flex;
    justify-content: space-between;
  }

  .author__info {
    flex-grow: 1;
  }

  .author__become-an-author__wrapper {
    width: 295px;

    @include desktop-lg {
      margin-top: 30px;
    }
  }
}
</style>
